import {
  Box,
  Button,
  ButtonGroup,
  ChoiceList,
  DatePicker,
  Filters,
  InlineStack,
  Tabs,
  Icon,
  useIndexResourceState,
} from "@shopify/polaris";
import React, {
  useCallback,
  useEffect,
  useState,
  useRef,
  useMemo,
} from "react";
import { ArrowRightIcon } from "@shopify/polaris-icons";
import "./index.css";
import ManualOrderTable from "./ManualOrderTable";
import { reqGetManualOrderNewList } from "../../../../api";
import CommonTableFilterSkeletonList from "../common/CommonTableFilterSkeletonList";
import SearchLoading from "../../../../components/SearchLoading";

const OrderListFilterBox = ({ setWalletData, toastFun,syncOpen,
  setSyncOpen, }) => {
  const [selected, setSelected] = useState(0); //tab 选择状态
  const [initPage, setInitPage] = useState(true); // 初始化页面
  const [collapsibleItem,setCollapsibleItem] = useState(false)// 展开所有子项
  const [requestParams, setRequestParams] = useState({
    page: 1,
    size: 20,
    payment_status: [],
    fulfillment_status: [],
    tag: 1,
    start_time: "",
    end_time: "",
    order_number: "",
  }); // 请求参数
  const [listData, setListData] = useState({}); //列表数据
  const [searchLoading, setSearchLoading] = useState(false); // 页面加载
  const [searchBtnLoading, setSearchBtnLoading] = useState(false); // 搜索按钮加载
  const [tabData, setTabData] = useState([
    {
      id: "a1",
      content: "All",
      accessibilityLabel: "All customers",
      panelID: "a1-1",
    },
    {
      id: "a2",
      content: <span>Unpaid(0)</span>,
      panelID: "a2-1",
    },
    {
      id: "a3",
      content: <span>In Processing(0)</span>,
      panelID: "a3-1",
    },
    {
      id: "a4",
      content: <span>Fulfilled(0)</span>,
      panelID: "a4-1",
    },
    {
      id: "a5",
      content: <span>Archived(0)</span>,
      panelID: "a5-1",
    },
  ]);
  // 使用 useMemo 缓存可选的订单列表，减少不必要的计算
  const selectableOrders = useMemo(() => {
    // const filterCondition = ({ dsm_payment_status }) =>
    //   dsm_payment_status === "Unpaid";
    const filteredList = listData?.list;
    // 如果过滤后为空则回退到原始列表，否则用过滤结果
    return filteredList;
  }, [listData?.list]); // 明确依赖 listData.list 和 selected
  const { selectedResources, allResourcesSelected, handleSelectionChange } =
    useIndexResourceState(selectableOrders);

  const dayShow = (isoDate) => {
    // 1. 创建Date对象
    const date = new Date(isoDate);

    const year = date.getFullYear(); // 2025
    let month = date.getMonth() + 1; // 月份从0开始需+1 → 2
    let day = date.getDate(); // 1
    if (month < 10) {
      month = "0" + month;
    }
    if (day < 10) {
      day = "0" + day;
    }
    // 3. 组合成 Y-M-D 格式（自动去除前导零）
    return `${year}-${month}-${day}`;
  };
  const getPageData = (data) => {
    setRequestParams((prev) => {
      getNewData({ ...prev, ...data });
      // 更新 queryParams 状态（确保 setRequestParams 能获得最新数据）
      return { ...prev, ...data };
    });
  };
  const getNewData = async (data) => {
    try {
      let params = {
        ...data,
      };
      if (params.start_time) {
        params.start_time = dayShow(params.start_time);
      }
      if (params.end_time) {
        params.end_time = dayShow(params.end_time);
      }

      let res = await reqGetManualOrderNewList(params);
      if (res.code === "200") {
        setWalletData(res.data.wallet_money);
        setListData(res.data);
        let summary = res.data.summary;
        if (summary) {
          setTabData([
            {
              id: "a1",
              content: "All",
              accessibilityLabel: "All customers",
              panelID: "a1-1",
            },
            {
              id: "a2",
              content: <span>Unpaid({summary.unpaid_count})</span>,
              panelID: "a2-1",
            },
            {
              id: "a3",
              content: <span>In Processing({summary.processing_count})</span>,
              panelID: "a3-1",
            },
            {
              id: "a4",
              content: <span>Fulfilled({summary.fulfilled_count})</span>,
              panelID: "a4-1",
            },
            {
              id: "a5",
              content: <span>Archived({summary.archived_count})</span>,
              panelID: "a5-1",
            },
          ]);
        }
        setInitPage(false);
        setSearchLoading(false);
        setSearchBtnLoading(false);
        setCollapsibleItem(false)
        handleSelectionChange("page", false, 0);
      } else {
      }
    } catch (error) {}
  };
  const handleTabChange = // 切换tab
    (selectedTabIndex) => {
      setSearchLoading(true);
      setSelected(selectedTabIndex);
      getPageData({
        page: 1,
        size: 20,
        payment_status: [],
        fulfillment_status: [],
        tag: selectedTabIndex + 1,
        start_time: "",
        end_time: "",
        order_number: "",
      });
      handleSelectionChange("page", false, 0);
    };

  const handlePaymentStatusChange = (value) => {
    getPageData({ page:1,payment_status: value });
  };
  const handleFiltersQueryChange = (value) => {
    if (value.length > 20) {
      return;
    }
    setRequestParams((prev) => ({
      ...prev,
      order_number: value,
    }));
  };
  const handlePaymentStatusRemove = () => {
    getPageData({ page:1,payment_status: [] });
  };
  const handleFulfillMentChange = (value) => {
    getPageData({ page:1,fulfillment_status: value });
  };
  const handleFulfillMentRemove = () => {
    getPageData({ page:1,fulfillment_status: [] });
  };

  const currentDate = new Date();
  const [{ month, year }, setDate] = useState({
    month: currentDate.getMonth(),
    year: currentDate.getFullYear(),
  }); // 添加日期
  // 添加日期
  const handleListedDateChange = (value) => {
    getPageData({
      page:1,
      start_time: value.start,
      end_time: value.end,
    });
  };
  const handleListedDateRemove = (value) => {
    getPageData({
      page:1,
      start_time: "",
      end_time: "",
    });
    handleSelectionChange("page", false, 0);
  };
  // 月份改变
  const handleMonthChange = useCallback(
    (month, year) => setDate({ month, year }),
    []
  );

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      if (requestParams.order_number !== "" && !searchLoading) {
        getPageData({
          page: 1,
          order_number: requestParams.order_number.trim(),
        });
        setSearchLoading(true);
      }
    }
  };

  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [requestParams]);
  const handleQueryValueRemove = () => {
    getPageData({
      page: 1,
      order_number: "",
    });
    setSearchLoading(true);
  };
  const handleFiltersClearAll = () => {
    getPageData({
      page:1,
      payment_status: [],
      fulfillment_status: [],
      start_time: "",
      end_time: "",
      order_number: "",
    });
  };

  const isMount = useRef(null);
  useEffect(() => {
    if (!isMount.current) {
      getPageData();
    }
    return () => {
      isMount.current = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
      if (syncOpen) {
        getPageData();
        setSyncOpen(false); // 执行后立即关闭，避免重复触发
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [syncOpen]); // 依赖项优化后，仅在 syncOpen 或 getPageData 变化时触发
  const filters =
    selected === 0
      ? [
          {
            key: "payment_status",
            label: "Payment Status",
            filter: (
              <ChoiceList
                title="Payment status"
                titleHidden
                choices={[
                  { label: "Paid", value: 1 },
                  { label: "Unpaid", value: 2 },
                  {
                    label: "Pending",
                    value: 3,
                  },
                  { label: "Refunded", value: 4 },
                  {
                    label: "Partially Refunded",
                    value: 5,
                  },
                ]}
                selected={requestParams.payment_status || []}
                onChange={handlePaymentStatusChange}
                allowMultiple
              />
            ),
            pinned: true,
          },
          {
            key: "fulfillment_status",
            label: "Fulfillment Status",
            filter: (
              <ChoiceList
                title="Fulfillment status"
                titleHidden
                choices={[
                  { label: "Unfulfilled", value: 1 },
                  { label: "Fulfilled", value: 2 },
                  { label: "In Processing", value: 3 },
                ]}
                selected={requestParams.fulfillment_status || []}
                onChange={handleFulfillMentChange}
                allowMultiple
              />
            ),
            pinned: true,
          },
          {
            key: "createdDate",
            label: (
              <Box>
                <InlineStack blockAlign="center" gap={200} wrap={false}>
                  <span>Start</span>
                  <Icon source={ArrowRightIcon} tone="base" />
                  <span>End</span>
                </InlineStack>
              </Box>
            ),
            filter: (
              <DatePicker
                month={month}
                year={year}
                onChange={handleListedDateChange}
                onMonthChange={handleMonthChange}
                selected={
                  requestParams.start_time && requestParams.end_time
                    ? {
                        start: requestParams.start_time,
                        end: requestParams.end_time,
                      }
                    : undefined
                  // 没有选择任何日期时传递 undefined
                  // 没有选择任何日期时传递 undefined
                }
                multiMonth
                allowRange
              />
            ),
            pinned: true,
          },
        ]
      : [
          {
            key: "createdDate",
            label: (
              <Box>
                <InlineStack blockAlign="center" gap={200} wrap={false}>
                  <span>Start</span>
                  <Icon source={ArrowRightIcon} tone="base" />
                  <span>End</span>
                </InlineStack>
              </Box>
            ),
            filter: (
              <DatePicker
                month={month}
                year={year}
                onChange={handleListedDateChange}
                onMonthChange={handleMonthChange}
                selected={
                  requestParams.start_time && requestParams.end_time
                    ? {
                        start: requestParams.start_time,
                        end: requestParams.end_time,
                      }
                    : undefined
                  // 没有选择任何日期时传递 undefined
                  // 没有选择任何日期时传递 undefined
                }
                multiMonth
                allowRange
              />
            ),
            pinned: true,
          },
        ];

  const appliedFilters = [];
  if (requestParams.payment_status && !isEmpty(requestParams.payment_status)) {
    const key = "payment_status";
    appliedFilters.push({
      key,
      label: disambiguateLabel(key, requestParams.payment_status),
      onRemove: handlePaymentStatusRemove,
    });
  }
  if (
    requestParams.fulfillment_status &&
    !isEmpty(requestParams.fulfillment_status)
  ) {
    const key = "fulfillment_status";
    appliedFilters.push({
      key,
      label: disambiguateLabel(key, requestParams.fulfillment_status),
      onRemove: handleFulfillMentRemove,
    });
  }
  if (requestParams.start_time && requestParams.end_time) {
    const key = "createdDate";
    appliedFilters.push({
      key,
      label: disambiguateLabel(key, requestParams),
      onRemove: handleListedDateRemove,
    });
  }

  const pageContent = (
    <Box>
      <Box className="order_list_tab">
        <Tabs
          tabs={tabData}
          selected={selected}
          onSelect={handleTabChange}
        ></Tabs>
      </Box>
      <Box className="product_filter">
        <Filters
          queryPlaceholder="Filter Dropshipman order"
          queryValue={requestParams.order_number}
          filters={filters}
          appliedFilters={appliedFilters}
          onQueryChange={handleFiltersQueryChange}
          onQueryClear={handleQueryValueRemove}
          onClearAll={handleFiltersClearAll}
        >
          <Box paddingInlineStart="0">
            <ButtonGroup variant="segmented">
              <Button
                onClick={() => {
                  getPageData({
                    page: 1,
                    order_number: requestParams.order_number.trim(),
                  });
                  setSearchLoading(true);
                  setSearchBtnLoading(true);
                }}
                size="micro"
                loading={searchBtnLoading}
              >
                Search
              </Button>
            </ButtonGroup>
          </Box>
        </Filters>
      </Box>
      <ManualOrderTable
        requestParams={requestParams}
        loading={false}
        setSearchLoading={setSearchLoading}
        getPageData={getPageData}
        toastFun={toastFun}
        selected={selected}
        listData={listData}
        setListData={setListData}
        selectableOrders={selectableOrders}
        selectedResources={selectedResources}
        allResourcesSelected={allResourcesSelected}
        handleSelectionChange={handleSelectionChange}
        collapsibleItem={collapsibleItem}
        setCollapsibleItem={setCollapsibleItem}
      />
    </Box>
  );
  return (
    <div style={{ position: "relative" }}>
      {initPage ? <CommonTableFilterSkeletonList /> : pageContent}
      {searchLoading && <SearchLoading />}
    </div>
  );
};

function disambiguateLabel(key, value) {
  switch (key) {
    case "payment_status":
      let pay_status = [
        { label: "Paid", value: 1 },
        { label: "Unpaid", value: 2 },
        {
          label: "Pending",
          value: 3,
        },
        { label: "Refunded", value: 4 },
        {
          label: "Partially Refunded",
          value: 5,
        },
      ];
      return (
        "Payment status: " +
        value
          ?.map(
            (val) =>
              pay_status.find((status) => status.value === val)?.label ||
              "Unknown"
          )
          .join(",")
      );
    case "fulfillment_status":
      let fulfillmentStatus = [
        { label: "Unfulfilled", value: 1 },
        { label: "Fulfilled", value: 2 },
        { label: "In Processing", value: 3 },
      ];
      return (
        "Fulfillment status: " +
        value
          ?.map(
            (val) =>
              fulfillmentStatus.find((status) => status.value === val)?.label ||
              "Unknown"
          )
          .join(",")
      );
    case "createdDate":
      let startDate1 = new Date(value.start_time);
      let endDate1 = new Date(value.end_time);

      if (value.start_time === value.end_time) {
        // Single day format
        return (
          <Box>
            <InlineStack blockAlign="center" gap={200} wrap={false}>
              <span>
                {startDate1.toLocaleDateString("en-US", {
                  month: "short",
                  day: "numeric",
                  year: "numeric",
                })}
              </span>
              <Icon source={ArrowRightIcon} tone="base" />
              <span>End</span>
            </InlineStack>
          </Box>
        );
      } else {
        const startYear = startDate1.getFullYear();
        const endYear = endDate1.getFullYear();

        // Base format without year
        const baseFormat = { month: "short", day: "numeric" };

        if (startYear === endYear) {
          // Same year - show year once at the end
          const startStr = startDate1.toLocaleDateString("en-US", baseFormat);
          const endStr = endDate1.toLocaleDateString("en-US", baseFormat);
          return (
            <Box>
              <InlineStack blockAlign="center" gap={200} wrap={false}>
                <span>{startStr}</span>
                <Icon source={ArrowRightIcon} tone="base" />
                <span>
                  {endStr}, {startYear}
                </span>
              </InlineStack>
            </Box>
          );
        } else {
          // Different years - show full date for both
          const fullFormat = { ...baseFormat, year: "numeric" };
          const startStr = startDate1.toLocaleDateString("en-US", fullFormat);
          const endStr = endDate1.toLocaleDateString("en-US", fullFormat);
          return (
            <Box>
              <InlineStack blockAlign="center" gap={200} wrap={false}>
                <span>{startStr}</span>
                <Icon source={ArrowRightIcon} tone="base" />
                <span>{endStr}</span>
              </InlineStack>
            </Box>
          );
        }
      }
    default:
      return value;
  }
}

function isEmpty(value) {
  if (Array.isArray(value)) {
    return value.length === 0;
  } else {
    return value === "" || value == null;
  }
}
export default OrderListFilterBox;
